<template>
  <div>
    <div id="download-recollection"><MainLogo></MainLogo></div>
    <DownloadButton style="margin-top: -2em;"></DownloadButton>
    <div class="textbox">
      <div class="text" style="margin-top: 2em;">
        <h2>Kingdom Hearts Re:Collection is a free archive of art assets and custom fonts created by Televo</h2>
        <p>Re:Collection contains hundreds of unique icons and fonts inspired from across the series, including worlds, combat abilities, key items, progression events and more. Icons can be classified into two artistic styles: DETAILED flashy artwork and MINIMAL coloured symbols.</p>
        <p>This archive is known for being featured in the majority of trackers, randomizers and in numerous modded projects throughout the community.</p>
        <p>If you decide to use these assets and fonts publicly, giving credit is much appreciated although not necessary. No doubt my time spent here exceeds 2000 hours so if you cherish what I do with all your heart, consider supporting me. Of those who have already done so, I am tremendously thankful.</p>
        <p>Feel free to contact me anytime via Email (televo.kh@gmail.com) or Discord (Televo#9400). And I hope my efforts here help you to create something magnificent.</p>
      </div>
    </div>
    <div class="button-container" style="margin-top: 0; margin-bottom: 3em; gap: 1.5em;">
      <a href="https://ko-fi.com/televo" target="_blank">
        <button @mousedown="playKupoSound"><h3>Donate Munny</h3></button>
      </a>
      <a href="https://discord.com/channels/@me/" target="_blank">
        <button @mousedown="playSelectSound"><h3>Contact Me</h3></button>
      </a>
    </div>
    <img class="preview" src="../assets/Preview.png" srcset="../assets/PreviewSmall.png 1200w, ../assets/Preview.png 2400w" alt="ReCollection Content Preview">
    <div id="icon-search"><IconSearch></IconSearch></div>
    <div id="font-preview"><FontPreview></FontPreview></div>
    <div class="textbox">
      <div class="text">
        <p>Fonts in Re:Collection are recreated faithfully, directly from the games where possible (such as KHTitle which uses characters from The World That Never Was). They also have improved letter spacing (specifically when set to metric, not optical spacing).</p>
        <p>Various languages are supported including English, French, German, Italian, Spanish, Turkish, Polish, Norwegian, Swedish, Russian, Portuguese, Danish, Indonesian and other latin-based languages.</p>
        <p>As the Scalan language hasn't been fully deciphered KHScala & KHScalaScirpt does contain translation inaccuracies.</p>
      </div>
    </div>
    <img class="translation" src="../assets/Translation.png" srcset="../assets/TranslationSmall.png 1200w, ../assets/Translation.png 2400w" alt="Scalan Translation">
    <DownloadButton></DownloadButton>
    <div id="special-thanks"><SpecialThanks></SpecialThanks></div>
    <div class="footer">
      <div class="footer-row" style="width: 48%; text-align: right;">
        <p @mousedown="playPopupSound"><a href="https://github.com/televo/kingdom-hearts-recollection/releases/download/v6.0/Kingdom-Hearts-ReCollection.zip">Download Re:Collection</a></p>
        <p @mousedown="playTabSound" @click="scroll('icon-search')">Jump to Icon Search</p>
        <p @mousedown="playTabSound" @click="scroll('font-preview')">Jump to Font Preview</p>
      </div>
      <div style="width: 4%;"></div>
      <div class="footer-row" style="width: 48%; text-align: left;">
        <p @mousedown="playKupoSound"><a href="https://ko-fi.com/televo" target="_blank">Donate Munny on KoFi</a></p>
        <p @mousedown="playSelectSound"><a href="https://discord.com/channels/@me/" target="_blank">Contact Me on Discord</a></p>
        <p @mousedown="playSelectSound"><a href="https://github.com/televo/kingdom-hearts-recollection" target="_blank">GitHub Repository</a></p>
      </div>
    </div>
    <div class="footer-mobile">
      <div class="footer-row" style="width: 100%; text-align: center;">
        <p @mousedown="playPopupSound"><a href="https://github.com/televo/kingdom-hearts-recollection/releases/download/v6.0/Kingdom-Hearts-ReCollection.zip">Download Re:Collection</a></p>
        <p @mousedown="playTabSound" @click="scroll('icon-search')">Jump to Icon Search</p>
        <p @mousedown="playTabSound" @click="scroll('font-preview')">Jump to Font Preview</p>
        <p @mousedown="playKupoSound"><a href="https://ko-fi.com/televo" target="_blank">Donate Munny on KoFi</a></p>
        <p @mousedown="playSelectSound"><a href="https://discord.com/channels/@me/" target="_blank">Contact Me on Discord</a></p>
        <p @mousedown="playSelectSound"><a href="https://github.com/televo/kingdom-hearts-recollection" target="_blank">GitHub Repository</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import MainLogo from '../components/MainLogo.vue';
import DownloadButton from '../components/DownloadButton.vue';
import IconSearch from '../components/IconSearch.vue';
import FontPreview from '../components/FontPreview.vue';
import SpecialThanks from '../components/SpecialThanks.vue';
import popupSound from "@/assets/audio/popup.mp3";
import selectSound from "@/assets/audio/select.mp3";
import tabSound from "@/assets/audio/tab.mp3";
import kupoSound from "@/assets/audio/kupo.mp3";
export default {
  name: 'ReCollection',
  components: {
    MainLogo,
    DownloadButton,
    IconSearch,
    FontPreview,
    SpecialThanks,
  },
  methods: {
    playPopupSound() {
      const popupAudio = new Audio(popupSound);
      popupAudio.play();
    },
    playSelectSound() {
      const selectAudio = new Audio(selectSound);
      selectAudio.play();
    },
    playTabSound() {
      const tabAudio = new Audio(tabSound);
      tabAudio.play();
    },
    playKupoSound() {
      const kupoAudio = new Audio(kupoSound);
      kupoAudio.play();
    },
  },
  setup() {
    const scroll = (id) => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };
    return {
      scroll,
    };
  },
}
</script>

<style scoped>
.footer, .footer-mobile {
  display: flex;
  justify-content: center;
  padding: 1.5em 5vw;
  margin-top: 2em;
  margin-bottom: 3.5em;
  color: var(--white);
  background: linear-gradient(to bottom, var(--black), var(--black) 50%, var(--indigo) 50%, var(--indigo));
  background-size: 100% 5px;
  border: none;
  outline: 2px solid var(--blue-light);
  filter: drop-shadow(0 0 1em var(--indigo))
          drop-shadow(0 0 0.5em var(--indigo));
}
.footer-mobile {
  display: none;
}
@media screen and (min-width: 1200px) {
  .footer {
    border-radius: 0.5em;
  }
}
@media screen and (max-width: 490px) {
  .footer {
    display: none;
  }
  .footer-mobile {
    display: flex;
  }
  .footer-row > p {
    color: var(--blue-light);
    padding: 0.2em 0;
    cursor: pointer;
  }
}
.footer-row > p {
  color: var(--blue-light);
  margin: 0;
  cursor: pointer;
}
.footer-row > p:hover {
  color: var(--white);
}
</style>